import {AxiosPromise} from 'axios';

import {ActionType} from '@typescript/common/actionTypes';
import {PRODUCT} from 'constants/actions';
import {ENDPOINTS} from 'constants/endpoints';
import {instanceGusaBackend} from 'libs/api';

/**
 * Fetches cms banner for product page
 *
 * @param {string} placeholder - banner placeholder name
 * @param {number} productId - current product id
 * @return {ActionType<AxiosPromise>} created action
 */
export const fetchProductBanner = (
    placeholder: string,
    productId: number,
): ActionType<AxiosPromise> => ({
    type: PRODUCT.FETCH_BANNER,
    payload: instanceGusaBackend({
        method: 'GET',
        url: ENDPOINTS.PRODUCT_GET_BANNER,
        params: {
            placeholder,
            productId,
            showWrapper: 0,
        },
    }),
});
